import React from 'react'
import { ModalBody, ModalHeader, Modal } from 'reactstrap'

export default function PreviewModal(props) {
  const close = () => {
    props.close('isPreviewOpen')
  }
  const showPreviewDocument = () => {
    if (!props.address) {
      if (props.isIpv) {
        return (
          <div className="d-flex flex-column p-2">
            <video className="img img-fluid" src={props.preview} controls autoPlay/>
          </div>
        )
      } 
      if (props.isPdf) {
        return <embed 
              id={'iframeData'}
              src={props.preview}
              type="application/pdf"
              height="600px"
              width="100%"
            />
      } 
      return (
        <div className="d-flex flex-column p-2">

          <img className="img img-fluid" src={props.preview} alt='preview-img' />
        </div>
      )
    }  
    return (
      <div className="d-flex flex-column p-2">

        <img className="img img-fluid" src={props.preview[0]}  alt='preview-1-img'/>
        <img className="img img-fluid" src={props.preview[1]}  alt='preview-2-img'/>
      </div>
    )
  }
  return (
    <Modal 
    isOpen={props.isOpen} 
    toggle={close} 
    className="modal-lg"
  >
    <ModalHeader toggle={close} />
    <ModalBody className="sample-container">
      {showPreviewDocument()}
    </ModalBody>
  </Modal>  
  
  )
}
